module.exports = __webpack_public_path__ + "img/fb-join.9ab9a85e.png";